'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var FlexColumnContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  height: 100%;\n"])));
var InputContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  width: 100%;\n  flex-grow: 0;\n  #chatinput {\n    margin-bottom: 0;\n  }\n  box-sizing: border-box;\n"], ["\n  width: 100%;\n  flex-grow: 0;\n  #chatinput {\n    margin-bottom: 0;\n  }\n  box-sizing: border-box;\n"])));
var ExpansionContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  width: 100%;\n  flex-grow: 1;\n  overflow: auto;\n"], ["\n  width: 100%;\n  flex-grow: 1;\n  overflow: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

exports.ExpansionContainer = ExpansionContainer;
exports.FlexColumnContainer = FlexColumnContainer;
exports.InputContainer = InputContainer;
